import React from 'react';

import { type MultiLevelMenuItem } from '@/common/types/multi-level-menu.type';
import { useFilterTags } from '@/features/collection-detail/hooks';
import ProductSearch from '@/features/store/components/product-search.component';
import { type FilteredDataType } from '@/features/store/types/filter.type';
import { isDesktop } from 'react-device-detect';
import { Swiper, SwiperSlide } from 'swiper/react';

import Button from '@/common/components/button';
import { orderMock } from '@/common/constants/filter-product-list.constant';

import 'swiper/css';

import CloseIcon from '~/public/assets/images/svg/close-line.svg';
import FilterIcon from '~/public/assets/images/svg/filter-icon.svg';

import Filter from './filter.component';

export interface Props {
  onSearch: (query: string) => void;
  filteredData: FilteredDataType;
  allCategories: MultiLevelMenuItem[];
}

export default function FilterTags({
  filteredData,
  allCategories,
  onSearch,
}: Props) {
  const { handleClick, removeIsDiscountedOrIsAvailable, removeSortFilter } =
    useFilterTags(filteredData);

  const CloseIconComponent = () => (
    <CloseIcon className="mr-1 inline-block h-5 w-5 text-black-100" />
  );

  return (
    <>
      <div className="mt-2 w-full lg:mt-0">
        <div className="flex w-full flex-row items-center justify-between gap-6">
          <div className="flex w-full flex-col gap-y-5 ">
            <div className="flex w-full grow flex-row items-center justify-start gap-[8px] overflow-auto">
              <div className="flex w-full flex-row items-center justify-start gap-[11px]">
                <Filter
                  categoryList={allCategories}
                  filteredData={filteredData}
                >
                  {isDesktop ? (
                    <Button
                      className=" h-11 w-11 !rounded-lg !border !border-solid !border-[#EDECEB] !bg-[#F2F1F1]  !p-[6px]"
                      type="filterTag"
                    >
                      <FilterIcon className="mx-auto inline-block" />
                    </Button>
                  ) : undefined}
                </Filter>

                <div className="hidden w-full max-w-[710px] cursor-grab lg:block">
                  {isDesktop && allCategories?.length > 0 ? (
                    <Swiper spaceBetween={11} slidesPerView={'auto'} freeMode>
                      {filteredData.orderBy.value.length > 0 && (
                        <SwiperSlide className="!w-fit">
                          <Button
                            type="black"
                            onClick={() => {
                              removeSortFilter();
                            }}
                            className="!text-white-default mr-[8px] w-fit flex-shrink-0 !rounded-lg !border !border-solid !border-[#EDECEB] !bg-[#191308] !p-[6px] !px-[8px] !py-[10px] text-sm font-medium"
                          >
                            <>
                              {
                                orderMock.find(
                                  (sortItem) =>
                                    sortItem.value ===
                                    filteredData.orderBy?.value
                                )?.label
                              }
                            </>
                            <CloseIconComponent />
                          </Button>
                        </SwiperSlide>
                      )}
                      {filteredData.isDiscounted && (
                        <SwiperSlide className="!w-fit">
                          <Button
                            type="black"
                            onClick={() => {
                              removeIsDiscountedOrIsAvailable('isDiscounted');
                            }}
                            className={
                              '!text-white-default w-fit !rounded-lg !border !border-solid !border-[#EDECEB] !bg-[#191308] !p-[8px] text-sm font-medium'
                            }
                          >
                            دارای تخفیف
                            <CloseIconComponent />
                          </Button>
                        </SwiperSlide>
                      )}
                      {filteredData.isAvailable && (
                        <SwiperSlide className="!w-fit">
                          <Button
                            type="black"
                            onClick={() => {
                              removeIsDiscountedOrIsAvailable('isAvailable');
                            }}
                            className={
                              '!text-white-default w-fit !rounded-lg !border !border-solid !border-[#EDECEB] !bg-[#191308] !p-[8px] text-sm font-medium'
                            }
                          >
                            فقط محصولات موجود
                            <CloseIconComponent />
                          </Button>
                        </SwiperSlide>
                      )}
                      {allCategories
                        .filter((item) => {
                          const selected = filteredData.category.find(
                            (category) => item.value === category.value
                          );
                          return (
                            (selected && filteredData.category.length > 0) ||
                            filteredData.category.length === 0
                          );
                        })
                        .map((item) => {
                          const selected = filteredData.category.find(
                            (category) => item.value === category.value
                          );
                          return (
                            <SwiperSlide key={item.value} className="!w-fit">
                              <Button
                                onClick={() => {
                                  handleClick(item);
                                }}
                                type={selected ? 'black' : 'filterTag'}
                                className={
                                  'w-fit !rounded-lg !border !border-solid !border-[#EDECEB] !p-[8px] text-sm font-medium'
                                }
                                icon={selected && <CloseIconComponent />}
                                iconPosition="end"
                              >
                                {item.label}
                              </Button>
                            </SwiperSlide>
                          );
                        })}
                    </Swiper>
                  ) : null}
                </div>
              </div>
            </div>
          </div>

          <ProductSearch
            placeholder="جستجو در میان محصولات کالکشن"
            className="hidden min-w-[370px] lg:!block"
            onSearch={onSearch}
          />
        </div>
      </div>
    </>
  );
}
